import requestManager from '../platformApi/requestManager'
import appHelper from "@util/appHelper";

export default {

    getItem(id, callback) {
        requestManager.request({
            url: 'portal/atlas/get',
            data: { id : id }
        }, (error, result) => {
            if (error)
            {
                appHelper.generalAjaxError(error);
                return;
            }

            if (result.errorCode)
            {
                appHelper.showHint(result.msg);
                return;
            }

            callback(result.data);
        });
    },

    getCommentList(data, callback) {
        requestManager.request({
            url: 'portal/atlas/comment/listByCommentId',
            data: data
        }, (error, result) => {
            if (error)
            {
                appHelper.generalAjaxError(error);
                return;
            }

            if (result.errorCode)
            {
                appHelper.showHint(result.msg);
                return;
            }

            callback(result);
        });
    },

    /**
     * @param   {Object}    data
     * @param   {Number}    data.atlasId
     * @param   {String}    data.content
     * @param   {Function}  callback
     */
    addComment(data, callback) {
        requestManager.request({
            url: 'portal/atlas/comment/add',
            method : 'post',
            data: data
        }, (error, result) => {
            if (error)
            {
                appHelper.generalAjaxError(error);
                return;
            }

            if (result.errorCode)
            {
                appHelper.showHint(result.msg);
                return;
            }

            callback(result);
        });
    },

    getRandomList(data = {}, callback) {
        requestManager.request({
            url: 'portal/atlas/randomList',
            data: data
        }, callback);
    },

    /**
     * @param   {String}    atlasId
     * @param   {String}    email
     * @param   {Function}  callback
     */
    sendEmail(atlasId, email, callback) {
        requestManager.request({
            url: 'portal/atlas/sendEmail',
            method : 'post',
            data: {
                atlasId : atlasId,
                email : email,
            }
        }, (error, result) => {
            if (error)
            {
                appHelper.generalAjaxError(error);
                return;
            }

            if (result.errorCode)
            {
                appHelper.showHint(result.msg);
                return;
            }

            callback(result);
        });
    },

    clickDown(id, callback) {
        requestManager.request({
            url : '/portal/atlas/v2/clickDown',
            data: {
                id: id
            }
        }, (error, result) => {

            if(error)
            {
                appHelper.generalAjaxError(error);
                return;
            }
            callback(result);
        });
    },

    getDownCount(id, callback) {
        requestManager.request({
            url : '/portal/atlas/getDownCount',
            data: {
                id: id
            }
        }, (error, result) => {

            if(error)
            {
                appHelper.generalAjaxError(error);
                return;
            }
            callback(result);
        });
    },
};
